// Nexmove Solutions - Content Data

export const companyInfo = {
  name: "NEXMOVE",
  fullName: "NEXMOVE Consulting Limited",
  tagline: "Indigenous Renewable Energy & Sustainable Solutions",
  logoUrl: "https://customer-assets.emergentagent.com/job_nexmove-rebrand/artifacts/jd3aryb8_logo.png"
};

export const heroSlides = [
  {
    id: 1,
    badge: "Indigenous Renewable Energy",
    headline: "Powering Progress,",
    headlineAccent: "Sustaining Tomorrow",
    tagline: "We bring clean, cost-effective energy and innovative agricultural solutions to communities across Nigeria.",
    image: "https://images.unsplash.com/photo-1509391366360-2e959784a276?w=1920&q=80"
  },
  {
    id: 2,
    badge: "Agro-Culture",
    headline: "Diversity and",
    headlineAccent: "Sustainability",
    tagline: "We redefine agriculture and its products.",
    image: "https://images.unsplash.com/photo-1500937386664-56d1dfef3854?w=1920&q=80"
  },
  {
    id: 3,
    badge: "Alternative",
    headline: "Light",
    headlineAccent: "Energy",
    tagline: "Illuminating possibilities with innovative energy solutions that power your world sustainably.",
    image: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?w=1920&q=80"
  },
  {
    id: 4,
    badge: "Renewable",
    headline: "Clean",
    headlineAccent: "Energy",
    tagline: "Provide electric energy to rural homes, which constitute 60% of the Nigerian Population.",
    image: "https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=1920&q=80"
  },
  {
    id: 5,
    badge: "Tailored-Made",
    headline: "Engineering",
    headlineAccent: "Solutions",
    tagline: "Providing affordable and efficient engineering solutions to industries and homes across Nigeria.",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?w=1920&q=80"
  },
  {
    id: 6,
    badge: "We Redefine",
    headline: "Agriculture and",
    headlineAccent: "Agricultural Products",
    tagline: "Dedicated to consumer satisfaction using the latest agricultural technologies.",
    image: "https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=1920&q=80"
  }
];

export const aboutContent = {
  title: "Who We Are",
  description: "NEXMOVE Consulting Limited is an integrated indigenous company dedicated to bringing alternative, clean, and cost-effective energy solutions to Nigeria. We redefine agriculture through a new 'agro-culture' that maintains diversity and achieves sustainability.",
  mission: {
    title: "Our Mission",
    text: "To provide quality, exceptional, cost-effective and cutting-edge energy, agro-culture and engineering technologies to consumers in Nigeria—ensuring environmental safety, long-term customer service, support and maintenance."
  },
  vision: {
    title: "Our Vision",
    text: "To become the leading indigenous renewable energy, agro-culture and engineering solution company providing quality and unimpeachable products, services and solutions to our clients in Nigeria."
  }
};

export const services = [
  {
    id: 1,
    title: "Renewable Energy",
    shortTitle: "Energy",
    description: "Providing rural and urban communities with uninterrupted power supply through sustainable, renewable, and clean energy resources and technologies.",
    outcome: "Reliable, clean power for 60% of Nigeria's population in rural communities."
  },
  {
    id: 2,
    title: "Agro-Culture",
    shortTitle: "Agriculture",
    description: "Redefining agriculture and agricultural products through latest technologies in poultry farming, fisheries, and agronomy.",
    outcome: "Sustainable food systems that maintain diversity and ensure consumer satisfaction."
  },
  {
    id: 3,
    title: "Engineering Solutions",
    shortTitle: "Engineering",
    description: "Providing latest, clean, affordable, tailor-made and energy efficient solutions to industries and homes across Nigeria.",
    outcome: "Reduced electricity costs and improved productivity for businesses and homes."
  }
];

export const valuePropositions = [
  "Committed to improving client productivity",
  "Maximizing profit through efficient solutions",
  "Making life more comfortable at home and business",
  "Environmental safety as a priority",
  "Long-term customer service and support"
];

export const processSteps = [
  {
    step: 1,
    title: "Consultation",
    description: "We understand your unique energy, agricultural, or engineering needs."
  },
  {
    step: 2,
    title: "Assessment",
    description: "Our experts evaluate and design tailored solutions for your requirements."
  },
  {
    step: 3,
    title: "Implementation",
    description: "We deploy cutting-edge technologies with precision and care."
  },
  {
    step: 4,
    title: "Support",
    description: "Ongoing maintenance and customer service ensure long-term success."
  }
];

export const contactInfo = {
  address: "Suite 2, #7 Mac Yoroki Street, Agungi–Lekki, Lagos Nigeria",
  phones: ["+234 (0) 706 748 2828", "+234 (0) 805 510 1411"],
  emails: ["enquiry@nexmovesolutions.com", "nexmoveconsult@yahoo.com"]
};

export const socialLinks = [
  { name: "Facebook", url: "https://facebook.com/nexmovesolutions", icon: "facebook" },
  { name: "Twitter", url: "https://twitter.com/nexmoveconsult", icon: "twitter" },
  { name: "LinkedIn", url: "https://linkedin.com/company/nexmove-consulting", icon: "linkedin" },
  { name: "Instagram", url: "https://instagram.com/nexmovesolutions", icon: "instagram" }
];

export const navLinks = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" }
];
